import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountSubscriptionManagerPage } from './account-subscription-manager.page';

const routes: Routes = [
    {
        path: '',
        component: AccountSubscriptionManagerPage
    }
];
@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class AccountSubscriptionManagerRoutingModule {}
